import React from "react";
import {
  Box,
  Card,
  Typography,
  Grid,
  Skeleton,
} from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

interface WSCardProps {
  title: string;
  value?: string; // optional for loading state
  subtitle?: string;
  icon: React.ElementType;
  trendText?: string; // +25%, -10% etc
  trendColor?: "green" | "red";
  footerText?: string;
  loading?: boolean; // new prop
}

const WSCard: React.FC<WSCardProps> = ({
  title,
  value,
  subtitle,
  icon: Icon,
  trendText,
  trendColor = "green",
  footerText,
  loading = false,
}) => {
  return (
    <Card
      sx={{
        borderRadius: "22px",
        padding: "20px",
        background: "linear-gradient(145deg, #2d2f36, #1f2127)",
        color: "#fff",
        minWidth: "220px",
        position: "relative",
        overflow: "hidden",
        height: 230,
      }}
    >
      {}
      <Grid container justifyContent="space-between" alignItems="center">
        <Box
          sx={{
            backgroundColor: "#c6ff00",
            width: 42,
            height: 42,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {loading ? <Skeleton variant="circular" width={22} height={22} /> : <Icon style={{ color: "#1f2127", fontSize: 22 }} />}
        </Box>

        <Box
          sx={{
            border: "1px solid rgba(255,255,255,0.3)",
            borderRadius: "50%",
            width: 36,
            height: 36,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          {loading ? <Skeleton variant="circular" width={18} height={18} /> : <TrendingUpIcon sx={{ fontSize: 18 }} />}
        </Box>
      </Grid>

      {}
      <Typography
        sx={{
          marginTop: 2,
          fontSize: "14px",
          color: "#b0b3b8",
        }}
      >
        {loading ? <Skeleton width="60%" /> : title}
      </Typography>

      {}
      <Typography
        sx={{
          fontSize: "28px",
          fontWeight: 700,
          marginTop: "6px",
        }}
      >
        {loading ? <Skeleton width="80%" /> : value}
      </Typography>

      {}
      {trendText && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginTop: 2,
            gap: 1,
          }}
        >
          {loading ? (
            <Skeleton variant="rectangular" width={60} height={24} sx={{ borderRadius: "20px" }} />
          ) : (
            <Box
              sx={{
                backgroundColor: trendColor === "green" ? "#0f5132" : "#842029",
                color: trendColor === "green" ? "#00ff9d" : "#ff6b6b",
                padding: "4px 10px",
                borderRadius: "20px",
                fontSize: "12px",
                fontWeight: 600,
              }}
            >
              {trendText}
            </Box>
          )}

          <Typography
            sx={{
              fontSize: "12px",
              color: "#b0b3b8",
            }}
          >
            {loading ? <Skeleton width={80} /> : "Since Last month"}
          </Typography>
        </Box>
      )}

      {}
      {footerText && (
        <Typography
          sx={{
            marginTop: 2,
            fontSize: "13px",
            color: "#d1d1d1",
          }}
        >
          {loading ? <Skeleton width="70%" /> : footerText}
        </Typography>
      )}
    </Card>
  );
};

export default WSCard;